<template>
  <v-form ref="form_6" v-model="formValid" lazy-validation>
    <v-container>
      <v-layout row>
        <v-flex xs12 class="pa-3">
          <v-layout row>
            <v-flex xs12>
              <v-container>
                <v-layout row wrap align-center>
                  <v-flex xs12 sm6 class="pb-1">
                    <h1 class="py-3">Contact Information</h1>
                    <p>Please provide contact information for the booking prior to departure.</p>
                  </v-flex>
                  <v-spacer></v-spacer>
                  <v-flex shrink>
                    <CountdownTimer />
                  </v-flex>
                </v-layout>
              </v-container>
            </v-flex>
          </v-layout>
          <ContactInfo />
         </v-flex>
      </v-layout>
    </v-container>

    <v-layout row xs12 class="py-4 justify-center">
      <v-btn
        @click="setPreviousStep()"
        class="accent_light"
      >
        <v-icon class="reverse">arrow_right_alt</v-icon>
        Previous
      </v-btn>
      <v-btn
        @click="setNextStep()"
        :disabled="testCompleteStep(getFormIndexByPath('/booking/contact')) === false"
        class="accent"
      >
        Continue
        <v-icon>arrow_right_alt</v-icon>
      </v-btn>
    </v-layout>
  </v-form>
</template>

<script>
import store from "../../store";
import Shared from "@/mixins/Shared";
import BookingFormMixin from "@/mixins/BookingFormMixin";
import ContactInfo from "@/components/forms/sections/ContactInfo.vue";
import CountdownTimer from "@/components/CountdownTimer.vue";

export default {
  name: "FormContact",
  props: [],
  store: store,
  mixins: [BookingFormMixin, Shared],
  components: { ContactInfo, CountdownTimer },
  data() {
    return {
      formValid: false
    };
  },
  mounted() {
    const step = this.getStepNumberByPath("/booking/contact");
    if (store.state.active !== step) {
      store.commit("setActiveStep", step);
    }
  }
};
</script>
